import { ErrorBoundaryRouted } from '@src/components/ErrorBoundary';
import { MarketsProvider } from '@talos/kyoko';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { DeviceRouter } from './DeviceRouter';

const browserRouter = createBrowserRouter([
  {
    path: '/speed-test',
    errorElement: <ErrorBoundaryRouted />,
    lazy: async () => {
      const { SpeedTestPage } = await import('../../speed-test/SpeedTestPage');
      return { Component: SpeedTestPage };
    },
  },
  {
    path: '*',
    element: (
      <MarketsProvider>
        <DeviceRouter />
      </MarketsProvider>
    ),
    errorElement: <ErrorBoundaryRouted />,
  },
]);

export const AppRoutes = () => <RouterProvider router={browserRouter} />;
